export enum PricingRegion {
  China = 'china',
  RestOfWorld = 'row',
  EuropeanEconomicArea = 'eea',
}
